import React from 'react';
import { useFormState } from 'react-hook-form';
import { TextFieldElement } from 'react-hook-form-mui';

export function RHFTextField({ hidden, disabled, slotProps, ...other }) {
  const { disabled: formDisabled } = useFormState({ control: other.control, name: other.name });

  return (
    <TextFieldElement
      {...other}
      disabled={disabled || formDisabled}
      type={hidden ? 'password' : other.type}
      sx={{ ...other.sx }}
      slotProps={{
        ...slotProps,
      }}
    />
  );
}